import { staticOfacRestriction } from "./constants";

interface OFACMessageProps {
  type: string;
  sideRail?: boolean;
}

function OFACMessage({ type = "course", sideRail = false }: OFACMessageProps) {
  return (
    <div className="bg-putty-400">
      <div className="max-w-[1280px] mx-auto">
        <div
          className={`w-full ${sideRail ? "xl:w-[824px]" : ""} flex flex-col gap-4 py-14 max-xl:px-4`}
        >
          <h2 className="m-0 md:text-3xl">This {type} is unavailable</h2>
          <p className="m-0 text-sm">
            {staticOfacRestriction.forType(type).description}
          </p>
        </div>
      </div>
    </div>
  );
}

export default OFACMessage;
